import { __decorate } from "tslib";
import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import i18n from "@/config/i18n";
import { DateType } from "../../home-screen.enum";
let PiHomeDataBlock = class PiHomeDataBlock extends Vue {
    constructor() {
        super(...arguments);
        this.DateType = DateType;
        this.type = DateType.Type1;
    }
    getVisible() {
        this.reset();
    }
    /**
     * 监听轮循的 type ，显示对应的数据
     */
    "Watch.showType"() {
        this.type = this.showType;
    }
    get valueNumber() {
        let value = this.valueKey && this.statisticsData[this.type][this.valueKey]
            ? this.statisticsData[this.type][this.valueKey]
            : 0;
        return value > 10000
            ? (value / 10000).toFixed(2) +
                '<span class="unit">' +
                i18n.t("unitText.wan") +
                this.unit +
                "</span>"
            : value + '<span class="unit">' + this.unit + "</span>";
    }
    reset() {
        this.type = DateType.Type1;
    }
    refreshClick(type) {
        this.type = type;
        this.$emit("on-type-change", type);
    }
};
__decorate([
    Prop({ default: "" })
], PiHomeDataBlock.prototype, "showType", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeDataBlock.prototype, "name", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeDataBlock.prototype, "valueKey", void 0);
__decorate([
    Prop({ default: i18n.t("yuan") })
], PiHomeDataBlock.prototype, "unit", void 0);
__decorate([
    Prop({
        default: () => {
            return {
                1: "",
                2: "",
                3: "",
            };
        },
    })
], PiHomeDataBlock.prototype, "statisticsData", void 0);
__decorate([
    Prop({ default: "" })
], PiHomeDataBlock.prototype, "oprPkId", void 0);
__decorate([
    Watch("oprPkId")
], PiHomeDataBlock.prototype, "getVisible", null);
__decorate([
    Watch("showType")
], PiHomeDataBlock.prototype, "Watch.showType", null);
PiHomeDataBlock = __decorate([
    Component
], PiHomeDataBlock);
export default PiHomeDataBlock;
